import { render } from "./ProviderSetupComponent.vue?vue&type=template&id=91c6ed9a"
import script from "./ProviderSetupComponent.vue?vue&type=script&lang=js"
export * from "./ProviderSetupComponent.vue?vue&type=script&lang=js"

import "./ProviderSetupComponent.vue?vue&type=style&index=0&id=91c6ed9a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__